import * as React from "react";
import { TextField } from "@mui/material";
import { LoginFormErrors } from "../../login.types";

interface EmailLoginStepProps {
    email: string;
    formErrors: LoginFormErrors;
    disabled?: boolean;
    emailTextFieldClass: string;
    onEmailChange: (value: string) => void;
    onClearEmailError: () => void;
    onKeyDown: (e: React.KeyboardEvent) => void;
}

export const EmailLoginStep: React.FC<EmailLoginStepProps> = ({
    email,
    formErrors,
    disabled = false,
    emailTextFieldClass,
    onEmailChange,
    onClearEmailError,
    onKeyDown,
}) => (
    <TextField
        fullWidth
        label="Email"
        type="email"
        value={email}
        disabled={disabled}
        onChange={(e) => {
            onEmailChange(e.target.value);
            onClearEmailError();
        }}
        onKeyDown={onKeyDown}
        error={!!formErrors.email}
        helperText={formErrors.email}
        autoComplete="email"
        size="small"
        placeholder="you@company.com"
        InputLabelProps={{ shrink: true }}
        className={emailTextFieldClass}
    />
);
